module.exports = __webpack_public_path__ + "img/1530602761.5fb0e757.jpg";